import { PlusOutlined } from '@ant-design/icons';
import { Form, Input, Select, Switch, Upload } from 'antd';
import { useEffect, useMemo } from 'react';
import { API_UPLOAD_BASEURL } from '../../../common/constants';
import {
  AppForm,
  closeDrawer,
  useAppDispatch,
  useAuthUser,
  useDrawer,
  useForm,
} from '../../../core';
import { FormUtils } from '../../merchants/utils/FormUtils';
import { ICategory } from '../types';

type TProps = {
  onFinish: (attributes: Record<string, any>) => void;
  isSubmitted: boolean;
};

export const CategoryForm: React.FC<TProps> = ({ onFinish, isSubmitted }) => {
  const { form } = useForm({ drawerId: 'CategoryDrawer' });
  const dispatch = useAppDispatch();
  const { auth } = useAuthUser();
  const { resource } = useDrawer<ICategory>();

  useEffect(() => {
    if (!isSubmitted) {
      return;
    }

    dispatch(closeDrawer());
  }, [isSubmitted, dispatch]);

  useEffect(() => {
    if (
      !resource ||
      resource.type !== 'Category' ||
      form.isFieldsValidating()
    ) {
      return;
    }

    form.setFieldsValue({
      name_en: resource.attributes.name_en,
      name_ar: resource.attributes.name_ar,
      enabled: resource.attributes.status,
      order: resource.attributes.order,
      icon: resource.attributes.icon
        ? [
            {
              uid: '-1',
              name: resource.attributes.icon,
              url: resource.attributes.icon,
              thumbnail: resource.attributes.icon,
            },
          ]
        : undefined,
    });
  }, [form, resource]);

  // Generate options for order dropdown
  const orderOptions = useMemo(
    () =>
      Array.from({ length: 50 }, (_, i) => i + 1).map((num) => ({
        value: num,
        label: num.toString(),
      })),
    [],
  );

  return (
    <AppForm form={form} onFinish={onFinish}>
      <Form.Item
        name={'name_en'}
        label="Name (English)"
        required
        rules={[{ required: true }]}
      >
        <Input maxLength={50} />
      </Form.Item>
      <Form.Item
        name={'name_ar'}
        label="Name (Arabic)"
        required
        rules={[{ required: true }]}
      >
        <Input maxLength={50} dir="rtl" />
      </Form.Item>
      <Form.Item
        name={'order'}
        label="Category Order"
        required
        rules={[{ required: true }]}
        initialValue={1}
      >
        <Select options={orderOptions} />
      </Form.Item>
      <Form.Item
        name={'icon'}
        label="Icon"
        valuePropName="fileList"
        getValueFromEvent={FormUtils().normFile}
        required
        rules={[{ required: true }]}
      >
        <Upload
          action={API_UPLOAD_BASEURL}
          listType="picture-card"
          accept="image/*"
          maxCount={1}
          headers={{
            Authorization: `Bearer ${auth?.access_token}`,
          }}
        >
          <button style={{ border: 0, background: 'none' }} type="button">
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </button>
        </Upload>
      </Form.Item>
      <Form.Item
        name={'enabled'}
        label="Status"
        valuePropName="checked"
        initialValue={true}
      >
        <Switch />
      </Form.Item>
    </AppForm>
  );
};
